import { TDescriptionValue } from 'shared/types/typographyComponents';

export const LIST: TDescriptionValue[][] = [
  [{ value: 'Предложения крупнейших банков, включая эксклюзивные условия' }],
  [{ value: 'Автоматическое заполнение анкеты через интеграцию с Госуслугами' }],
  [{ value: 'Заключение договоров и оформление сделки без посещения банка или МФЦ' }],
];

export const DESCRIPTION = [
  [
    {
      value:
        'Цифровой сервис, который позволяет пользователям выбрать ипотечную программу, подать заявку и получить одобрение банка дистанционно.',
    },
  ],
];
